import React from "react";
import { breadcrumbs } from "../../common/breadcrumbs";
import { TopBanner } from "../../common/TopBanner";
import Table from "semantic-ui-react/dist/commonjs/collections/Table";
import { Link } from "../../lib/Link";
import { openContactSelector } from "../../common/callUtil"
//                <Link to="/flow#f1_1"> or <Link to="#f1_1">
//                  <span>お申込みからご契約まで</span>
//                </Link>

export const flow = type => {
  document.title = "トランクルームをお探しなら『ハローストレージ』【公式】｜トランクルームのご契約について";
  return (
    <div className="container">
      {breadcrumbs(type, [{ text: "トランクルームのご契約について" }])}

      <div className="flow">
        <div className="toppanel">
          <div className="title">トランクルームのご契約について</div>
        </div>
        <div className="content">
          <div className="cont_menu">
            <div className="item">
              <div>
                <Link to="/flow/#f1_1" className="responder">
                  <span>ご契約の流れ</span>
                </Link>
              </div>
            </div>
            <div className="item">
              <div>
                <Link to="/flow/#f1_2" className="responder">
                  <span>ご契約に必要なもの</span>
                </Link>
              </div>
            </div>
            <div className="item">
              <div>
                <Link to="/flow/#f1_3" className="responder">
                  <span>お支払いについて</span>
                </Link>
              </div>
            </div>
            <div className="item">
              <div>
                <Link to="/flow/#f1_4" className="responder">
                  <span>ご契約時の注意事項</span>
                </Link>
              </div>
            </div>
            <div className="item">
              <div>
                <Link to="/flow/#f1_5" className="responder">
                  <span>保険について</span>
                </Link>
              </div>
            </div>
          </div>
          <a id="section1" />
          <div className="section" id="f1_1">
          <div className="title">ご契約の流れ</div>
            {/*
            <div className="scroll_x">
              <div className="cont_menu_step">
                <Link to="/flow/#f1_1_1">
                  <div className="item responder">
                    <div>STEP 1</div>
                    <img src="resource/img/post.png" />
                    <div>物件を決める</div>
                  </div>
                </Link>
                <Link to="/flow/#f1_1_2">
                  <div className="item responder">
                    <div>STEP 2</div>
                    <img src="resource/img/note.png" />
                    <div>お申込み</div>
                  </div>
                </Link>
                <Link to="/flow/#f1_1_3">
                  <div className="item responder">
                    <div>STEP 3</div>
                    <img src="resource/img/passport.png" />
                    <div>
                      契約関連書類の
                      <br />
                      お受け取り
                    </div>
                  </div>
                </Link>
                <Link to="/flow/#f1_1_4">
                  <div className="item responder">
                    <div>STEP 4</div>
                    <img src="resource/img/purses.png" />
                    <div>
                      書類の返送
                      <br />
                      契約金のお支払い
                    </div>
                  </div>
                </Link>
                <Link to="/flow/#f1_1_5">
                  <div className="item responder">
                    <div>STEP 5</div>
                    <img src="resource/img/key.png" />
                    <div>
                      ご契約
                      <br />
                      鍵のお受け取り
                    </div>
                  </div>
                </Link>
              </div>
            </div>
            */}
            <div className="cont_step">
              <div className="item" id="f1_1_1">
                <div>
                  <div>STEP1</div>
                  <div>物件を決める</div>
                </div>
                <div>
                  まずはお客様のご希望の物件をお探しください！
                  <br />
                  ハローストレージの物件は、物件名のほか、エリア、広さなど、いろいろな探し方ができます。
                  <br />
                  お客様のご利用シーンを思い浮かべながら<a href="/list/" target="_blank" style={{'display': 'inline-block', 'color': '#4a90e2'}} className="atag_hover_underline">「トランクルームを探す」</a>より物件を検索してください。
                </div>
              </div>
              <div className="item" id="f1_1_2">
                <div>
                  <div>STEP2</div>
                  <div>お申込み</div>
                </div>
                <div>
                  「お申し込み」ボタンが表示されているお部屋はWEBからお申し込みいただけます！
                  <br />
                  ※空き状況は各部屋タイプの【▼詳細を表示】をクリックするとご確認いただけます。
                  <br />
                  ※お支払方法やご利用開始日に応じた初期費用は、「見積もり」ボタンをクリックしてご確認ください。
                  <br />
                  <br />
                  ご不明な点は
                  <a
                    className="lnk_contact link atag_hover_underline"
                    style={{'display': 'inline-block', 'color': '#4a90e2'}}
                    onClick={() => openContactSelector({ eventTrackingId: 'tel_action_flow' })}
                  >
                    お問い合わせ
                  </a>
                  より電話かメールでご相談ください。
                </div>
              </div>
              <div className="item" id="f1_1_4">
                <div>
                  <div>STEP3</div>
                  <div>初期費用のお支払いとご利用開始</div>
                </div>
                <div>
                  初期費用を期日までにお振込みください。
                  <br />
                  ※WEBからお申し込みで、クレジットカードの手続きを行っていただきますと、初期費用の決済が完了できスピーディーです。
                  <br />
                  ※ご契約完了後にキャンセルされる場合はキャンセル料を申し受けます。（1契約あたり5,000円）
                  <br />
                  <br />
                  メールにてダイヤル錠の暗証番号もしくは交通系ICカードの登録方法をご案内いたします。ご契約いただいた物件により、宅配便でのご送付の場合もございますので、その際は、別途宅配便の伝票番号が記載されたメールをご確認ください。ご利用開始日になりましたらご利用いただけます。
                  <br />
                  ※個人のお客様は本人確認書類、法人のお客様は商業登記簿謄本（発行後3ヶ月以内）の提出がご利用開始日までにない場合、鍵のご案内（もしくは送付）はできかねますので予めご了承ください。
                  <div className="item" id="f1_1_6">
                    <div className="title">
                      <br />
                      <br />
                      ■初期費用について （通常契約の場合）
                      <br />
                    </div>

                    <Table celled unstackable>
                      <Table.Body>
                        <Table.Row>
                          <Table.HeaderCell>使用料</Table.HeaderCell>
                          <Table.Cell>
                            当月分の使用料（日割）から、翌月分までの使用料
                          </Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.HeaderCell>管理費</Table.HeaderCell>
                          <Table.Cell>
                            当月から翌月分まで
                            <br />
                            （2,200円x2ヶ月分=4,400円）
                          </Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.HeaderCell>事務手数料</Table.HeaderCell>
                          <Table.Cell>使用料の1ヶ月分</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.HeaderCell>鍵代</Table.HeaderCell>
                          <Table.Cell>
                            屋外型トランクルーム：4,400円
                            <br />
                            屋内型トランクルーム：3,080円
                            <br />※
                            物件によっては発生しません。詳細はお問合せの際にご確認ください。
                          </Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.HeaderCell singleLine>
                            セキュリティ登録料
                          </Table.HeaderCell>
                          <Table.Cell>屋内型トランクルーム：1,100円</Table.Cell>
                        </Table.Row>
                        <Table.Row>
                          <Table.HeaderCell singleLine>
                            安心保証パック<br />又は安心保証パック＋
                          </Table.HeaderCell>
                          <Table.Cell>
                            当月から翌月分まで
                            <br />
                            1,100円（550円×2ヶ月分=1,100円）～
                            <div className="text">※詳細は「<a href="/anshinpack" target="_blank" className="atag_hover_underline">ハロー安心保証パック</a>」をご参照ください。</div>
                          </Table.Cell>
                        </Table.Row>
                      </Table.Body>
                    </Table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="section" id="f1_2">
            <div className="title">ご契約に必要なもの</div>
            <div className="pair_block">
              <div className="item">
                <div className="title">個人のお客様</div>
                <div className="text indent">
                  <span>1. 契約者本人を確認できる書類</span>
                  <span>
                    下記のいずれか1点をご提出ください。
                    <br />
                    ・ご契約の住所・氏名と内容が一致する本人確認
                    <br />
                    書類のコピー（運転免許証・健康保険証・パスポート・住民票等）
                    <br />
                    ・外国人登録証（外国籍の方）
                    <br />
                    ・印鑑
                  </span>
                  <span>2. 勤務先</span>
                  <span>
                    3. 第二連絡先（緊急連絡先）
                    <br />
                    すべてのお客様に緊急時の連絡先を伺っております。
                  </span>
                  <span>4. 金融機関お届け印（※口座振替の場合のみ）</span>
                </div>
              </div>
              <div className="item">
                <div className="title">法人のお客様</div>
                <div className="text indent">
                  <span>1. 商業登記簿謄本（発行後3ヶ月以内）</span>
                  <span>2. 会社実印（※WEB申込みの場合、不要）</span>
                  <span>3. 金融機関お届け印（※口座振替の場合のみ）</span>
                </div>
              </div>
            </div>
          </div>
          <div className="section" id="f1_3">
            <div className="title">お支払いについて</div>
            <div className="block">
              <div className="title">クレジットカード決済</div>
              <div className="text">
                VISA、MasterCard、JCB、アメリカン・エキスプレスが取扱可能です。
              </div>
              <img src="resource/img/credit_cart.png" />
              <div className="text">
                ※ ただし、一部プラン及び一部物件は除きます。
              </div>
            </div>
            <div className="block">
              <div className="title">口座振替</div>
              <div className="text">
                月々のお支払いは契約者様ご本人名義の口座より自動振替でお支払いいただきます。
                <br />
                ※口座引き落とし時には引落手数料(金110円)がかかります。
              </div>
            </div>
            <div className="block">
              <div className="title">
                <span>振替口座の新規登録　/　</span>
                <span>振替口座の変更</span>
              </div>
              <div className="text">
                簡単で手軽なインターネットでの口座振替のお手続きをお勧めしております。
                <br />
                <br />
                振替依頼書へのご記入、ご捺印の手間がなく、確実にご登録いただけます。
                <br />
                <br />※
                取扱い可能な金融機関に制限がございます。詳細はこちらからご確認ください。
                <br />
                <br />
                <a href="http://www.muf.bk.mufg.jp/collect/net_bank.html" target="_blank" className="atag_hover_underline">お取扱い金融機関一覧の確認 &gt;&gt;</a>
                <br />
                <br />※ 三菱UFJファクター（株）のサイトへリンクします。
                <br />※ 通常通り、書面でのお手続きも可能です。
              </div>
              <a href="/atp/" target="_blank">
                <img src="resource/img/netbank_login.png" />
              </a>
              <div className="text">
                <br />※
                ログインID/パスワードをお持ちのお客様は上記「ログイン」よりお手続きください。
                <br />※
                ログインID/パスワードの発行をご希望のお客様はお電話にてお問合せください。
                <br />
                <br />
                取扱いのない金融機関をご希望の場合、もしくは書面でのお手続きをご希望の方は以下より印刷してご郵送ください。<br />
                <a href="/change_process_.pdf?20210219" target="_blank" className="atag_hover_underline">口座振替記入用紙の印刷はこちらから>></a>
                <br />
                <br />
                【口座振替記入用紙送付先】
                <br />
                〒101-0021
                <br />
                東京都千代田区外神田4-14-1 秋葉原UDXビル20階
                <br />
                エリアリンク株式会社
                <br />
                カスタマーセンター行
              </div>
            </div>
          </div>
          <div className="section" id="f1_4">
            <div className="title">ご契約時の注意事項</div>
            <div className="text indent">
              <span>
                1.ご契約者様とお支払名義人は、同一でお願いいたします。
              </span>
              <span>
                2.ご提示頂いたお客様情報に不備がある場合は、ご利用開始が遅れますので、ご注意ください。
              </span>

              <span>
                3.契約内容を変更される場合は再度お手続きが必要となります。
              </span>
            </div>
          </div>
          <div className="section" id="f1_5">
            <div className="title">保険について</div>
            <div className="text">
              ご利用の皆様にトランクルーム内に収容された財物に対して、当社では次の内容の保険が自動付帯されております。
            </div>
            <Table celled unstackable>
              <Table.Body>
                <Table.Row>
                  <Table.HeaderCell>補償内容</Table.HeaderCell>
                  <Table.Cell>
                    50万円/1事故・1室
                    </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.HeaderCell>補償事故</Table.HeaderCell>
                  <Table.Cell>
                    火災、破裂、爆発、盗難（外部からの不法侵入により警察へ被害届けが提出されているもの）
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.HeaderCell>補償対象外の事故</Table.HeaderCell>
                  <Table.Cell>
                    ご利用者の故意、過失による事故の場合、使用契約で収納が禁止されているものは、上記補償事故に拘わらず保険の対象外となります。
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.HeaderCell>保険期間</Table.HeaderCell>
                  <Table.Cell>
                    使用契約に定める契約開始日より保険を開始し、契約期間終了日までとします。但し、使用契約が解除された場合には、解除日をもって保険期間を終了します。
                  </Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
            <div className="text">※ 詳細は使用契約にてご確認下さい。</div>
          </div>
          <div className="section" id="f2_1">
            <div className="title">更新について</div>
            <div className="text">
              契約は1年契約とさせていただきます。ご解約のご連絡がない限りは自動更新となり、更新月に更新料として使用料の0.5ヵ月分をいただきます。
              <br />
              ※ ご契約内容によってその限りではございません。
            </div>
          </div>
          <div className="section" id="f2_2">
            <div className="title">解約について</div>
            <div className="text">
              ・最短で、お電話いただきました月の翌月末日でのご解約とさせていただきます。
              <br />
              ・月末日でのご解約となりますので、日割りでのご解約は承っておりません。ご了承ください。
              <br />
              <br />
              <a href="/mypage3/?action=cancel" target="_blank" className="atag_hover_underline">解約ページはこちら&gt;&gt;</a>
            </div>
          </div>
          <div className="section">
            <div className="title">原状回復について</div>
            <div className="text">
              ご解約後、お部屋の点検を行った際、
              <a href="/images/flow/genjyokaihuku.pdf" target="_blank" className="atag_hover_underline">このような状態</a>
              の場合、原状回復費用が発生いたします。
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./pages/new/flow.jsx